import { ElementKind } from './enums'
import { AssessmentData, SectionData } from './types'

function getAllAssessments(sections: SectionData[]) {
  return sections.flatMap(sec => {
    return (
      sec.elements?.flatMap<AssessmentData>(element =>
        element.kind === ElementKind.ASSESSMENT ? (element as AssessmentData) : [],
      ) || []
    )
  })
}

export default getAllAssessments
